<template>
  <w-icon-wrapper icon-name='work-equals-icon'>
    <g
      id='Gruppe_25442'
      data-name='Gruppe 25442'
    >
      <path
        id='Pfad_55768'
        d='M20,10H4A1,1,0,0,1,4,8H20a1,1,0,0,1,0,2Z'
        data-name='Pfad 55768'
        fill='currentColor'
      />
    </g>
    <g
      id='Gruppe_25443'
      data-name='Gruppe 25443'
    >
      <path
        id='Pfad_55769'
        d='M20,16H4a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2Z'
        data-name='Pfad 55769'
        fill='currentColor'
      />
    </g>
    <rect
      id='Rechteck_4028'
      data-name='Rechteck 4028'
      fill='none'
      height='24'
      width='24'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEquals' };
</script>
